import {
  GET_BADGES,
  GET_BADGE,
  ADD_BADGE,
  DELETE_BADGE,
  UPDATE_BADGE,
  BADGES_LOADING,
  BADGE_LOADING,
  CLEAR_CURRENT_BADGE,
  GET_USER_BADGES
} from '../actions/types';

const initialState = {
  badges: [],
  currentBadge: null,
  userBadges: [],
  loading: false,
  badgeLoading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_BADGES:
      return { ...state, badges: action.payload, loading: false };
    case GET_BADGE:
      return { ...state, currentBadge: action.payload, badgeLoading: false };
    case ADD_BADGE:
      return { ...state, badges: [action.payload, ...state.badges], currentBadge: action.payload };
    case UPDATE_BADGE:
      return {
        ...state,
        badges: state.badges.map(b => b._id === action.payload._id ? action.payload : b),
        currentBadge: action.payload
      };
    case DELETE_BADGE:
      return { ...state, badges: state.badges.filter(b => b._id !== action.payload), currentBadge: null };
    case BADGES_LOADING:
      return { ...state, loading: true };
    case BADGE_LOADING:
      return { ...state, badgeLoading: true };
    case CLEAR_CURRENT_BADGE:
      return { ...state, currentBadge: null, badgeLoading: false };
    case GET_USER_BADGES:
      return { ...state, userBadges: action.payload, loading: false };
    default:
      return state;
  }
}
